module.exports = __webpack_public_path__ + "static/img/changping.7d9161f.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/changping.png
// module id = MuGq
// module chunks = 4